(function ($) {
  let recaptchaChecked = false

  $(function () {
    const button = $('#send');

    if (button.length > 0) {
      // Si une requête Ajax est en cours ou non
      let busy = null,
        noty = $('#noty'),
        loader = $('#loader');

      noty.hide();
      loader.hide();

      // Soumission de l'idée
      button.on('click', function (e) {
        e.preventDefault();

        let error = false,
          alertCheck = false,
          form = $('#contactForm');

        form.find('[required]').each(function () {
          // On vérifie si le champ est vide ou pas
          if ($.trim($(this).val()) === '') {
            $(this).css('border-color', '#FF8A8A');
            error = true;
          } else {
            $(this).css('border-color', '#edf3f5');
          }
          // On vérifie si la checkbox id=rgpd est checked
          const id = $(this).attr('id');
          if (id === 'rgpd' && !$(this).is(':checked')){
            if (!error) {
              alertCheck = true;
            }
            error = true;
          }
        });

        if (!error && recaptchaChecked) {
          if (busy)
            busy.abort();

          loader.show();

          busy = $.ajax({
            // eslint-disable-next-line no-undef
            url: ajaxurl,
            type: 'POST',
            data: form.serialize(),
            success: function (response) {
              // On vide le formulaire
              form[0].reset();
              if (response === 'success') {
                // Affichage du message de succès
                noty.attr('class', 'alert alert-success').html('Merci ! Votre message a bien été envoyé');
              }

              if (response === 'error') {
                // Affichage du message d'erreur
                noty.attr('class', 'alert alert-danger').html('Une erreur est survenue pendant l\'envoi de votre message, veuillez réessayer.');
              }

              if (response === 'captcha') {
                // Affichage du message d'erreur captcha
                noty.attr('class', 'alert alert-danger').html('La vérification du CAPTCHA a échouée, veuillez réessayer.');
              }

              loader.hide();
            },
          });
        } else {
          // Affichage du message d'erreur
          if (!error && !recaptchaChecked) {
            noty.attr('class', 'alert alert-danger').html('Veuillez valider le CAPTCHA')
          } else {
            (alertCheck)
              ? noty.attr('class', 'alert alert-danger').html('Veuillez cocher la case RGPD')
              : noty.attr('class', 'alert alert-danger').html('Veuillez renseigner tous les champs obligatoires');
          }
        }

        // On affiche la div de notification
        noty.slideDown();
        noty.delay(5000).slideUp();

        return false;
      });
    }
  });

  function recaptchaCallback() {
    recaptchaChecked = true;
  }
  window.recaptchaCallback = recaptchaCallback;

})(jQuery);



// WEBPACK FOOTER //
// ./scripts/util/contact.js